import React from 'react';

import {Audio} from '@pexip/components';

import connect from '../assets/connect.flac';
import disconnect from '../assets/disconnect.flac';
import test from '../assets/test.flac';
import {logger} from '../logger';
import {useAudioOutput} from '../hooks/userMedia';

const sounds = {
    connect,
    disconnect,
    test,
};

export const PlaySound: React.FC<
    React.ComponentProps<'audio'> & {
        onSuccess?: (audio: HTMLAudioElement | null) => void;
        sinkId?: string;
        sound: keyof typeof sounds;
        play: boolean;
    }
> = ({sinkId, sound, play, onSuccess, ...props}) => {
    const selectedAudioOutput = useAudioOutput();

    const selectedAudioOutputDeviceId = selectedAudioOutput?.deviceId;

    return (
        <Audio
            onFailure={logOnFailure}
            onSuccess={onSuccess}
            src={sounds[sound]}
            sinkId={sinkId ?? selectedAudioOutputDeviceId}
            play={play}
            {...props}
        />
    );
};

function logOnFailure(reason: unknown) {
    logger.warn({reason}, 'failed to play sound');
}
